import { useMutation, useQuery, keepPreviousData } from '@tanstack/react-query';
import { createdApi } from '@/shared/api/sets/created';

const useCreatedBoxList = (param: API.CreatedBoxList.Req, enabled: boolean) => {
    return useQuery({
        queryKey: ['created-list', param],
        queryFn: () => createdApi.getCreatedBoxList(param),
        placeholderData: keepPreviousData,
        enabled: enabled,
    });
};

const useCreatedHistoryList = (param: API.CreatedHistoryList.Req, enabled?: boolean) => {
    return useQuery({
        queryKey: ['list', 'created-history', param],
        queryFn: () => createdApi.getCreatedHistList(param),
        placeholderData: keepPreviousData,
        enabled: enabled,
    });
};

const useCreatedBoxDetail = (param: API.CreatedBoxDetail.Req, enabled = true) =>
    useQuery({
        queryKey: ['detail', 'created-box', param],
        queryFn: () => createdApi.getCreatedBoxDetail(param),
        enabled: param.examId !== undefined && enabled,
        staleTime: 0,
        refetchOnMount: true,
        refetchOnWindowFocus: true,
    });

const useCreatedBoxPublishedHistory = (param: API.CreatedBoxPublishedHistory.Req) =>
    useQuery({
        queryKey: ['history', 'created-box', param],
        queryFn: () => createdApi.getCreatedBoxPublishedHistory(param),
    });

const useSaveCreate = () =>
    useMutation({
        mutationKey: ['create', 'save'],
        mutationFn: (param: API.SaveCreateBox.Req) => createdApi.postSaveCreate(param),
    });

const useUpdateCreated = () =>
    useMutation({
        mutationKey: ['update', 'created'],
        mutationFn: (param: API.UpdateCreatedBox.Req) => createdApi.updateCreated(param),
    });

const useDeleteCreated = () =>
    useMutation({
        mutationKey: ['delete', 'created'],
        mutationFn: (param: API.DeleteCreatedBox.Req) => createdApi.deleteCreated(param),
    });

const useCreatedBoxRange = () =>
    useMutation({
        mutationKey: ['created-post', 'range'],
        mutationFn: (param: API.CreatedBoxRange.Req) => createdApi.postCreatedBoxRange(param),
    });

// createdQueries 객체에서 커스텀 훅을 반환
export const createdBoxQueries = {
    postSaveCreated: useSaveCreate,
    postUpdateCreated: useUpdateCreated,
    postDeleteCreated: useDeleteCreated,
    postCreatedBoxRange: useCreatedBoxRange,
    getCreatedHistoryList: useCreatedHistoryList,
    getCreatedBoxList: useCreatedBoxList,
    getCreatedBoxDetail: useCreatedBoxDetail,
    getCreatedBoxPublishedHistory: useCreatedBoxPublishedHistory,
};
